/* ============================================================
   SIGIL MAIDEN — MAIN JAVASCRIPT
   Global interactive behaviour. Loaded deferred.
   Liquid-dependent data (routes, strings) is set inline
   in layout/theme.liquid before this file loads.
============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     HEADER — scroll state
  ---------------------------------------------------------- */
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    window.addEventListener('scroll', function () {
      siteHeader.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     MOBILE NAV DRAWER
  ---------------------------------------------------------- */
  const hamburger    = document.querySelector('.header-hamburger');
  const mobileDrawer = document.querySelector('.mobile-nav-drawer');

  function openMobileNav() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileNav);

  var mobileClose   = document.querySelector('.mobile-nav-close');
  var mobileOverlay = document.querySelector('.mobile-nav-drawer__overlay');
  if (mobileClose)   mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  /* ----------------------------------------------------------
     SCROLL ANIMATIONS
  ---------------------------------------------------------- */
  var animObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        animObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.anim').forEach(function (el) {
    animObserver.observe(el);
  });

  /* ----------------------------------------------------------
     CART DRAWER — open / close
  ---------------------------------------------------------- */
  var cartDrawer  = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* Trigger cart render — defined in cart-drawer.liquid and exposed globally */
    if (window.sigilRenderCart) window.sigilRenderCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openCartDrawer);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  /* Expose for use in other scripts */
  window.sigilCart = { open: openCartDrawer, close: closeCartDrawer };

  /* ----------------------------------------------------------
     CART — update count badge
  ---------------------------------------------------------- */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  window.sigilUpdateCartCount = updateCartCount;

  /* ----------------------------------------------------------
     QUICK ADD — add single-variant product to cart
  ---------------------------------------------------------- */
  function sigilQuickAdd(variantId, btn) {
    if (!variantId || btn.disabled) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    var cartNotifSections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

    var routes = window.routes || {};
    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: cartNotifSections })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function (addData) {
        var notification = document.querySelector('cart-notification');
        if (notification && addData.sections) {
          var itemKey = addData.items && addData.items[0] && addData.items[0].key;
          if (itemKey) notification.renderContents(Object.assign({}, addData, { key: itemKey }));
        }
        return fetch((routes.cart_url || '/cart') + '.js').then(function (r2) { return r2.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        btn.textContent = '✓';
        setTimeout(function () { openCartDrawer(); }, 400);
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 3000);
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
  }

  /* Expose globally so inline onclick handlers in snippets can call it */
  window.sigilQuickAdd = sigilQuickAdd;

  /* ----------------------------------------------------------
     PRODUCT GALLERY — thumbnail switching (delegated, CSP-safe)
     Supports image, video, and external_video media types.
  ---------------------------------------------------------- */
  var galleryCurrentIdx = 0;
  var galleryMediaData = null; // parsed from data-media attribute

  function getGalleryMedia() {
    if (galleryMediaData) return galleryMediaData;
    var gallery = document.getElementById('pdp-gallery');
    if (!gallery || !gallery.dataset.media) return [];
    try { galleryMediaData = JSON.parse(gallery.dataset.media); } catch(e) { galleryMediaData = []; }
    return galleryMediaData;
  }

  function sigilSetThumb(idx) {
    var media = getGalleryMedia();
    var item = media[idx];
    if (!item) return;
    galleryCurrentIdx = idx;

    var zoomBtn = document.querySelector('.gallery-zoom-btn');
    var galleryMain = document.getElementById('gallery-main');
    if (!galleryMain) return;

    if (item.type === 'video') {
      // Replace zoom btn with video player
      var videoHtml = '<div class="pdp-gallery__video" id="pdp-gallery-video">' +
        '<video controls playsinline autoplay style="width:100%;height:auto;display:block;border-radius:var(--card-radius,2px);"' +
        (item.poster ? ' poster="' + item.poster + '"' : '') + '>';
      if (item.sources) {
        item.sources.forEach(function(src) {
          videoHtml += '<source src="' + src.url + '" type="' + src.mime + '">';
        });
      }
      videoHtml += '</video></div>';
      galleryMain.innerHTML = videoHtml;

    } else if (item.type === 'external_video') {
      var embedSrc = '';
      if (item.host === 'youtube') {
        embedSrc = 'https://www.youtube-nocookie.com/embed/' + item.external_id + '?autoplay=1';
      } else if (item.host === 'vimeo') {
        embedSrc = 'https://player.vimeo.com/video/' + item.external_id + '?autoplay=1';
      }
      galleryMain.innerHTML = '<div class="pdp-gallery__video">' +
        '<iframe src="' + embedSrc + '" allow="autoplay; fullscreen" allowfullscreen' +
        ' style="width:100%;aspect-ratio:16/9;border:none;display:block;border-radius:var(--card-radius,2px);">' +
        '</iframe></div>';

    } else if (item.type === 'model') {
      // 3D model — render <model-viewer> web component
      var modelHtml = '<div class="pdp-gallery__model" id="pdp-gallery-model">' +
        '<model-viewer' +
        ' src="' + (item.glb || '') + '"' +
        (item.usdz ? ' ios-src="' + item.usdz + '"' : '') +
        ' poster="' + (item.poster || '') + '"' +
        ' alt="' + (item.alt || '3D model') + '"' +
        ' camera-controls auto-rotate shadow-intensity="1"' +
        ' style="width:100%;height:100%;min-height:400px;display:block;background:var(--off-white);">' +
        '</model-viewer>' +
        '</div>';
      galleryMain.innerHTML = modelHtml;
      // Load model-viewer web component if not already registered
      if (!window.customElements.get('model-viewer')) {
        if (window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0' }]);
        }
      }

    } else {
      // Image — restore zoom btn if needed
      var hasNonImage = document.getElementById('pdp-gallery-video') || document.getElementById('pdp-gallery-model');
      if (hasNonImage) {
        // Re-create the zoom btn structure after a non-image media type
        var btnHtml = '<button class="gallery-zoom-btn" type="button" data-gallery-zoom="' + idx + '" aria-label="Open image in full screen">' +
          '<img id="gallery-main-img" src="' + (item.src || '') + '" alt="' + (item.alt || '') + '" loading="lazy">' +
          '<span class="gallery-zoom-icon" aria-hidden="true">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>' +
          '</span></button>';
        galleryMain.innerHTML = btnHtml;
      } else {
        var mainImg = document.getElementById('gallery-main-img');
        var btn = galleryMain.querySelector('.gallery-zoom-btn');
        if (mainImg) {
          // Clear srcset/sizes first — browser prioritises srcset over src when both are set,
          // which causes the old image to remain visible even after src changes.
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = item.src || '';
          if (item.alt) mainImg.alt = item.alt;
        }
        if (btn) btn.setAttribute('data-gallery-zoom', idx);
      }
    }
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-idx]');
    if (!thumb || !thumb.closest('.product-gallery__thumbs')) return;
    var idx = parseInt(thumb.getAttribute('data-thumb-idx') || '0', 10);
    sigilSetThumb(idx);
    document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ----------------------------------------------------------
     PRODUCT GALLERY — hover zoom (cursor-tracked)
  ---------------------------------------------------------- */
  (function () {
    // Only on devices that support hover (not touch-only)
    if (!window.matchMedia('(hover: hover)').matches) return;

    document.addEventListener('mousemove', function (e) {
      var btn = e.target.closest('.pdp-gallery[data-image-zoom] .gallery-zoom-btn');
      if (!btn) return;
      var img = btn.querySelector('img');
      if (!img) return;
      var rect = btn.getBoundingClientRect();
      var x = (((e.clientX - rect.left) / rect.width) * 100).toFixed(2);
      var y = (((e.clientY - rect.top) / rect.height) * 100).toFixed(2);
      img.style.transformOrigin = x + '% ' + y + '%';
    });

    document.addEventListener('mouseleave', function (e) {
      var btn = e.target.closest('.pdp-gallery[data-image-zoom] .gallery-zoom-btn');
      if (!btn) return;
      var img = btn.querySelector('img');
      if (img) img.style.transformOrigin = 'center center';
    }, true);
  })();

  /* ----------------------------------------------------------
     PRODUCT GALLERY — lightbox (click to zoom)
  ---------------------------------------------------------- */
  (function () {
    var lb, lbImg, lbClose, lbPrev, lbNext, lbCounter;
    var media = [];
    var current = 0;

    function buildLightbox() {
      lb = document.createElement('div');
      lb.className = 'gallery-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Image viewer');
      lb.innerHTML =
        '<div class="gallery-lb__backdrop"></div>' +
        '<div class="gallery-lb__content">' +
          '<button class="gallery-lb__close" aria-label="Close">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
          '<button class="gallery-lb__nav gallery-lb__prev" aria-label="Previous image">' +
            '<svg width="16" height="28" viewBox="0 0 16 28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 2L4 14l8 12"/></svg>' +
          '</button>' +
          '<div class="gallery-lb__img-wrap"><img class="gallery-lb__img" src="" alt="" loading="eager"></div>' +
          '<button class="gallery-lb__nav gallery-lb__next" aria-label="Next image">' +
            '<svg width="16" height="28" viewBox="0 0 16 28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 2l8 12-8 12"/></svg>' +
          '</button>' +
          '<div class="gallery-lb__counter"></div>' +
        '</div>';
      document.body.appendChild(lb);
      lbImg     = lb.querySelector('.gallery-lb__img');
      lbClose   = lb.querySelector('.gallery-lb__close');
      lbPrev    = lb.querySelector('.gallery-lb__prev');
      lbNext    = lb.querySelector('.gallery-lb__next');
      lbCounter = lb.querySelector('.gallery-lb__counter');

      lb.querySelector('.gallery-lb__backdrop').addEventListener('click', closeLb);
      lbClose.addEventListener('click', closeLb);
      lbPrev.addEventListener('click', function () { navigate(-1); });
      lbNext.addEventListener('click', function () { navigate(1); });
    }

    function openLb(idx) {
      if (!lb) buildLightbox();
      media = getGalleryMedia();
      // Skip opening lightbox for non-image media (they render inline)
      var item = media[idx || 0];
      if (item && (item.type === 'video' || item.type === 'external_video' || item.type === 'model')) return;
      current = idx || 0;
      showSlide(current);
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }

    function closeLb() {
      if (!lb) return;
      lb.classList.remove('open');
      document.body.style.overflow = '';
    }

    function showSlide(idx) {
      if (!media.length) return;
      // Skip over non-image media when navigating
      var attempts = 0;
      do {
        current = (idx + media.length) % media.length;
        idx = current + 1;
        attempts++;
      } while (attempts < media.length && media[current] && media[current].type !== 'image');

      var item = media[current];
      if (!item || item.type !== 'image') return;

      lbImg.src = item.src || '';
      lbImg.alt = item.alt || '';
      lbCounter.textContent = (current + 1) + ' / ' + media.length;
      lbPrev.style.display = media.length > 1 ? '' : 'none';
      lbNext.style.display = media.length > 1 ? '' : 'none';
    }

    function navigate(dir) { showSlide(current + dir); }

    /* Delegated open */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gallery-zoom]');
      if (!btn) return;
      openLb(parseInt(btn.getAttribute('data-gallery-zoom') || '0', 10));
    });

    /* Keyboard */
    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('open')) return;
      if (e.key === 'Escape')     closeLb();
      if (e.key === 'ArrowLeft')  navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    /* Touch swipe */
    var touchStartX = 0;
    document.addEventListener('touchstart', function (e) {
      if (!lb || !lb.classList.contains('open')) return;
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!lb || !lb.classList.contains('open')) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) navigate(dx < 0 ? 1 : -1);
    }, { passive: true });
  })();

  /* ----------------------------------------------------------
     QUICK ADD — delegated listener on document
     Handles [data-quick-add] buttons rendered in product-card.liquid
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-quick-add');
    if (variantId) sigilQuickAdd(parseInt(variantId, 10), btn);
  });

  /* ----------------------------------------------------------
     SWATCHES — delegated listener for [data-swatch-href]
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-swatch-href]');
    if (!swatch) return;
    var href = swatch.getAttribute('data-swatch-href');
    if (href) window.location.href = href;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var swatch = e.target.closest('[data-swatch-href]');
    if (!swatch) return;
    e.preventDefault();
    var href = swatch.getAttribute('data-swatch-href');
    if (href) window.location.href = href;
  });

  /* ----------------------------------------------------------
     SIZING CHART MODAL — open / close
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sizing-open]');
    if (openBtn) {
      var id = openBtn.getAttribute('data-sizing-open');
      var modal = document.getElementById(id);
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modal.querySelector('.sizing-modal__close') && modal.querySelector('.sizing-modal__close').focus();
      return;
    }
    var closeBtn = e.target.closest('[data-sizing-close]');
    if (closeBtn) {
      var id2 = closeBtn.getAttribute('data-sizing-close');
      var modal2 = document.getElementById(id2);
      if (!modal2) return;
      modal2.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.sizing-modal[aria-hidden="false"]');
    if (!open) return;
    open.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  });

  /* ----------------------------------------------------------
     SHARE BUTTON — Web Share API + copy-link fallback
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.share-btn');
    if (!btn) return;
    var wrap    = btn.closest('.share-btn-wrap');
    var url     = (wrap && wrap.dataset.shareUrl)   || window.location.href;
    var title   = (wrap && wrap.dataset.shareTitle) || document.title;
    var text    = (wrap && wrap.dataset.shareText)  || '';
    var confirm = wrap && wrap.querySelector('.share-btn__confirm');

    if (navigator.share) {
      navigator.share({ title: title, text: text, url: url }).catch(function () {});
    } else {
      navigator.clipboard.writeText(url).then(function () {
        if (!confirm) return;
        confirm.hidden = false;
        setTimeout(function () { confirm.hidden = true; }, 2500);
      }).catch(function () {});
    }
  });

  /* ----------------------------------------------------------
     COLLECTION FILTERS — toggle open/close
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-filter-toggle]');
    if (!btn) return;
    var filters = document.querySelector('.collection-filters');
    if (!filters) return;
    var open = filters.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ----------------------------------------------------------
     COLLECTION SORT — change via select
  ---------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.collection-sort__select');
    if (!sel) return;
    var base = window.location.pathname;
    var search = window.location.search
      .replace(/[?&]sort_by=[^&]*/g, '')
      .replace(/^\?/, '')
      .replace(/^&/, '');
    window.location.href = base + '?sort_by=' + encodeURIComponent(sel.value) + (search ? '&' + search : '');
  });

  /* ----------------------------------------------------------
     COLLECTION FILTER CHECKBOXES — navigate on change
  ---------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var chk = e.target.closest('[data-filter-checkbox]');
    if (!chk) return;
    var params = [];
    // Collect all checked checkboxes
    document.querySelectorAll('[data-filter-checkbox]').forEach(function (c) {
      if (c.checked) {
        params.push(encodeURIComponent(c.name) + '=' + encodeURIComponent(c.value));
      }
    });
    // Preserve price range if set
    document.querySelectorAll('[data-filter-price]').forEach(function (p) {
      if (p.value !== '' && p.name) {
        params.push(encodeURIComponent(p.name) + '=' + encodeURIComponent(p.value));
      }
    });
    // Preserve current sort
    var sortMatch = window.location.search.match(/[?&]sort_by=([^&]*)/);
    if (sortMatch) params.push('sort_by=' + sortMatch[1]);
    window.location.href = window.location.pathname + (params.length ? '?' + params.join('&') : '');
  });

  /* ----------------------------------------------------------
     COLLECTION PRICE FILTER — debounced navigate on change
  ---------------------------------------------------------- */
  (function () {
    var priceTimer;
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-filter-price]')) return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        var params = [];
        // Collect all checked checkboxes
        document.querySelectorAll('[data-filter-checkbox]').forEach(function (c) {
          if (c.checked) {
            params.push(encodeURIComponent(c.name) + '=' + encodeURIComponent(c.value));
          }
        });
        // Collect price range values
        document.querySelectorAll('[data-filter-price]').forEach(function (p) {
          if (p.value !== '' && p.name) {
            params.push(encodeURIComponent(p.name) + '=' + encodeURIComponent(p.value));
          }
        });
        var sortMatch = window.location.search.match(/[?&]sort_by=([^&]*)/);
        if (sortMatch) params.push('sort_by=' + sortMatch[1]);
        window.location.href = window.location.pathname + (params.length ? '?' + params.join('&') : '');
      }, 800);
    });
  })();

  /* ----------------------------------------------------------
     FILTER DRAWER — open / close
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    // Open button (must have data-filter-drawer-open="drawer-id")
    var openBtn = e.target.closest('[data-filter-drawer-open]');
    if (openBtn) {
      var drawerId = openBtn.getAttribute('data-filter-drawer-open');
      var drawer = document.getElementById(drawerId);
      if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      return;
    }
    // Close button or overlay
    var closeEl = e.target.closest('[data-filter-drawer-close]');
    if (closeEl) {
      var panel = closeEl.closest('[data-filter-drawer]');
      if (panel) { panel.classList.remove('open'); panel.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    }
  });

  // Keyboard close (Escape)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDrawer = document.querySelector('[data-filter-drawer].open');
    if (openDrawer) { openDrawer.classList.remove('open'); openDrawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  });

  /* ----------------------------------------------------------
     FACETS SORT — navigate on select change
  ---------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var sortSel = e.target.closest('[data-facets-sort]');
    if (!sortSel) return;
    var params = [];
    // Preserve active filter checkboxes
    document.querySelectorAll('[data-filter-checkbox]').forEach(function (c) {
      if (c.checked) params.push(encodeURIComponent(c.name) + '=' + encodeURIComponent(c.value));
    });
    // Preserve active price filters
    document.querySelectorAll('[data-filter-price]').forEach(function (p) {
      if (p.value !== '' && p.name) params.push(encodeURIComponent(p.name) + '=' + encodeURIComponent(p.value));
    });
    // Add new sort value
    if (sortSel.value) params.push('sort_by=' + encodeURIComponent(sortSel.value));
    window.location.href = window.location.pathname + (params.length ? '?' + params.join('&') : '');
  });

  /* ----------------------------------------------------------
     COLLAPSIBLE CONTENT — delegated, CSP-safe
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-collapsible-trigger]');
    if (!btn) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var items = btn.closest('.collapsible-items');
    if (items && items.dataset.closeOthers === 'true') {
      items.querySelectorAll('[data-collapsible-trigger]').forEach(function (b) {
        if (b === btn) return;
        b.setAttribute('aria-expanded', 'false');
        var icon = b.querySelector('.collapsible-icon');
        if (icon) icon.style.transform = '';
        var body = b.nextElementSibling;
        if (body) body.style.maxHeight = '0';
      });
    }
    btn.setAttribute('aria-expanded', String(!expanded));
    var icon = btn.querySelector('.collapsible-icon');
    if (icon) icon.style.transform = expanded ? '' : 'rotate(45deg)';
    var body = btn.nextElementSibling;
    if (body) body.style.maxHeight = expanded ? '0' : body.scrollHeight + 200 + 'px';
  });

  /* ----------------------------------------------------------
     EXTERNAL LINKS — open in new tab
  ---------------------------------------------------------- */
  document.querySelectorAll('a[href]').forEach(function (link) {
    try {
      if (link.hostname && link.hostname !== window.location.hostname) {
        link.target = '_blank';
        link.rel    = 'noreferrer noopener';
      }
    } catch (e) { /* skip */ }
  });

})();
